import React from "react";
import { BarChart, Bar, Tooltip, ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend, Label } from "recharts";
import { convertCapitalize } from "../../../../utils/allFormatter";
import Loader from "../../Loader";

const CustomizedAxisTick = (props) => {
  const { x, y, stroke, payload } = props;
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} textAnchor="end" fill="#666">
        ${payload.value}
      </text>
    </g>
  );
};
const colors = {
  0: "#10439F",
  1: "#EB8153",
  2: "#A9A9A9",
  3: "#97BE5A",
  4: "#5E1675",
  5: "#00224D",
  6: "#00224D",
  7: "#40A578",
  8: "#E8DFCA",
  9: "#FF9800",
  10: "#FF5BAE",
  11: "#A3D8FF",
  12: "#8576FF",
  13: "#008170",
  14: "#00A9FF",
  15: "#CA8787",
};
export const TripleBarCharts = (props) => {
  const formatMoney = (amount) => {
    const absAmount = Math.abs(amount);

    if (absAmount >= 1.0e9) {
      return (amount / 1.0e9).toFixed(1) + "B";
    } else if (absAmount >= 1.0e6) {
      return (amount / 1.0e6).toFixed(1) + "M";
    } else if (absAmount >= 1.0e3) {
      return (amount / 1.0e3).toFixed(1) + "K";
    } else {
      return amount.toString();
    }
  };

  const renderCustomRateLabel = (props) => {
    const { x, y, width, value } = props;
    return (
      <text x={x + width / 2} y={y} fill="#000" textAnchor="middle" dy={-10}>
        {formatMoney(value)}
      </text>
    );
  };
  let barKeys = [];
  if (props?.data?.length !== 0) {
    barKeys = Object.keys(props?.data[0])?.filter((key) => key !== "name");
  }
  return (
    <div>
      {props?.data?.length !== 0 ? (
        <ResponsiveContainer
          height={props.height ? props.height : 450}
          width="100%"
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          <BarChart
            data={props?.data}
            barSize={50}
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: 100,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis tick={<CustomizedAxisTick />} />
            <Tooltip cursor={{ fill: "transparent" }} />
            <Legend
              //   verticalAlign="top"
              height={40}
              content={(props) => {
                return (
                  <ul className="d-flex justify-content-center my-3">
                    {props.payload.map((entry, index) => (
                      <li key={`item-${index}`} className="ms-5 d-flex align-items-center">
                        <div
                          style={{
                            width: "15px",
                            height: "15px",
                            backgroundColor: `${entry.color}`,
                            marginRight: "5px",
                          }}
                        ></div>
                        {convertCapitalize(entry.value)}
                      </li>
                    ))}
                  </ul>
                );
              }}
            />
            {barKeys.map((key, index) => (
              <Bar key={key} dataKey={key} fill={colors[index]} label={renderCustomRateLabel} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Loader forProcess={true} />
      )}
    </div>
  );
};
